export const statusCodes: Record<string, string> = {
    PL: 'In Planung',
    PR: 'In Vorbereitung',
    EX: 'In Durchführung',
    FI: 'Abgeschlossen',
};
